import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import LanguageItem from './LanguageItem';
import { getSupportedLanguages } from './data';

const LanguageSwitcher = React.forwardRef(({ switchLanguage, handleRequestClose }, ref) => {
  const supportedLanguages = getSupportedLanguages();
  const showFlags = !supportedLanguages.some(({ locale }) => locale === 'ru');
  const { app } = useSelector((state) => state);
  const currentLocale = app?.locale;
  const currentLocaleCode = currentLocale?.locale;

  return (
    <div className="messages-list language-list" style={{ width: 150 }} ref={ref}>
      <ul className="list-unstyled">
        {supportedLanguages.map((language) => {
          const isActive = currentLocaleCode === language.locale;
          return (
            <LanguageItem
              key={language.languageId}
              language={language}
              handleRequestClose={handleRequestClose}
              switchLanguage={switchLanguage}
              isActive={isActive}
              showFlag={showFlags}
            />
          );
        })}
      </ul>
    </div>
  );
});

LanguageSwitcher.propTypes = {
  switchLanguage: PropTypes.func.isRequired,
  handleRequestClose: PropTypes.func.isRequired,
};

export default LanguageSwitcher;
